module.exports = __webpack_public_path__ + "static/rd-smart-tax-app.87281c16.png";